import { useEffect, useState } from "react";
import { clinicConfig } from "../config/clinic";

const DAY_MAP = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
const DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

function computeStatus() {
  const { timezone, days, open, close, openLabel } = clinicConfig.hours;
  const now = new Date();
  const fmt = new Intl.DateTimeFormat("en-US", {
    timeZone: timezone,
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const parts = Object.fromEntries(
    fmt.formatToParts(now).map((p) => [p.type, p.value])
  );
  const day = DAY_MAP[parts.weekday];
  let hour = parseInt(parts.hour, 10);
  if (hour === 24) hour = 0;
  const minute = parseInt(parts.minute, 10);
  const nowMin = hour * 60 + minute;

  const [oh, om] = open.split(":").map(Number);
  const [ch, cm] = close.split(":").map(Number);
  const openMin = oh * 60 + om;
  const closeMin = ch * 60 + cm;

  const isOpen = days.includes(day) && nowMin >= openMin && nowMin < closeMin;

  let detail;
  if (isOpen) {
    detail = `Open until ${clinicConfig.hours.closeLabel} today`;
  } else {
    // Find the next open day (searching up to 7 days ahead).
    let nextDay = null;
    for (let i = 0; i <= 7; i++) {
      const candidate = (day + i) % 7;
      const sameDayBeforeOpen = i === 0 && nowMin < openMin;
      if (days.includes(candidate) && (i > 0 || sameDayBeforeOpen)) {
        nextDay = { candidate, offset: i };
        break;
      }
    }
    if (nextDay) {
      const label =
        nextDay.offset === 0
          ? "today"
          : nextDay.offset === 1
          ? "tomorrow"
          : DAY_NAMES[nextDay.candidate];
      detail = `Opens ${label} at ${openLabel}`;
    } else {
      detail = `Opens ${clinicConfig.hours.daysLabel}`;
    }
  }

  return { isOpen, label: isOpen ? "Open now" : "Closed now", detail };
}

export function useOpenStatus() {
  const [status, setStatus] = useState(computeStatus);
  useEffect(() => {
    const id = setInterval(() => setStatus(computeStatus()), 30000);
    return () => clearInterval(id);
  }, []);
  return status;
}
